import styled from "styled-components";
import {
  Type,
  Icon,
  Tab,
  List,
  Flex,
} from "discover.medical.react-component-library";

export const DrugInteractionKeyTab = styled(Tab)`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.font.size.xs};
    max-width: initial;
  }
`;

export const DrugInteractionKeyIcon = styled(Icon)`
  flex-shrink: 0;
  margin-bottom: auto;
`;

export const DrugInteractionKeyTitle = styled(Type)`
  line-height: ${({ theme }) => theme.line.height.icon};
`;

export const DrugInteractionKeyTitleListItemWrapper = styled(Type)`
  margin-bottom: ${({ theme }) => theme.space.md};
`;

export const DrugInteractionKeyTitleListItem = styled(List.Item)`
  &::before {
    line-height: 0.5 !important;
  }
`;

export const DrugInteractionKeyItemTextContent = styled(Flex)`
  margin-left: 0.75rem;
`;
